import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Login from '../views/login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: 'login',
    component: Login,
    
  }
]

const router = new VueRouter({
  routes
})

// router.beforeEach((to, from, next) => {
//   if (store.state.user || to.path === '/login') {
//     next()
//   } else {
//     next({ path: '/login' })
//   }
// })

export default router
